import React from "react";
import { FormattedMessage } from "react-intl";

export function CookiesContent() {
  return (
    <div>
      <FormattedMessage id="b2b.cookies-content.text" />
    </div>
  );
}

CookiesContent.propTypes = {};

export default React.memo(CookiesContent);
